export default "__VITE_ASSET__9e2f4bc4__"